import React from 'react';

const SVGLoader = () => (
  <svg
    width="81"
    height="65"
    viewBox="0 0 81 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_462_27196)">
      <path
        d="M37.311 27.7001C37.5512 25.9911 39.145 24.6056 40.8709 24.6056H74.3088C76.0347 24.6056 77.2391 25.9911 76.9989 27.7002L72.6577 58.5894C72.4175 60.2985 70.8237 61.684 69.0978 61.684H35.6599C33.934 61.684 32.7296 60.2985 32.9698 58.5894L37.311 27.7001Z"
        fill="white"
        stroke="#00262B"
        strokeWidth="2.75"
      />
      <path
        d="M14.3344 0.242266C10.8942 0.242266 7.7173 3.00392 7.23852 6.41059L2.89732 37.2999C2.41854 40.7065 4.81922 43.4682 8.25937 43.4682H24.9783H41.6973C45.1374 43.4682 48.3144 40.7065 48.7931 37.2999L53.1343 6.4106C53.6131 3.00392 51.2124 0.242266 47.7723 0.242266H14.3344Z"
        fill="white"
        stroke="white"
        strokeWidth="3.45791"
      />
      <path
        d="M10.3425 6.41059C10.5827 4.7015 12.1765 3.31601 13.9024 3.31601H47.3403C49.0662 3.31601 50.2706 4.70151 50.0304 6.4106L45.6892 37.2999C45.449 39.0089 43.8552 40.3944 42.1293 40.3944H8.69136C6.96547 40.3944 5.76107 39.0089 6.00127 37.2999L10.3425 6.41059Z"
        fill="white"
        stroke="#00262B"
        strokeWidth="2.75"
      />
      <path
        d="M48.2786 52.4212H45.342L54.7009 33.868H57.8753L62.0192 52.4212H59.0826L55.8894 37.1927H55.7431L48.2786 52.4212ZM49.829 45.1648H59.5535L59.2289 47.4749H49.5043L49.829 45.1648Z"
        fill="#00262B"
      />
      <path
        d="M32.6534 16.7597L35.2022 17.5199C31.5485 24.9163 26.108 29.2308 18.357 31.5319C18.1532 30.9156 17.5323 29.7239 17.1181 29.1281C24.5594 27.2584 29.5543 23.4575 32.6534 16.7597ZM24.6218 16.924C25.8626 23.0055 29.729 27.3817 36.8841 29.0254C36.2015 29.6006 35.2278 30.7717 34.7325 31.4908C27.2352 29.4774 23.6225 24.7724 22.0281 17.6637L24.6218 16.924ZM19.4175 15.4242H38.4221L38.0814 17.8486H19.0768L19.4175 15.4242ZM28.0274 12.178H30.6001L29.936 16.9035H27.3633L28.0274 12.178Z"
        fill="#00262B"
      />
      <path
        opacity="0.7"
        d="M-36.0829 -23.699L10.3068 -18.5847L-4.25464 85.0256L-50.6443 79.9114L-36.0829 -23.699Z"
        fill="url(#paint0_linear_462_27196)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_462_27196"
        x1="-26.0031"
        y1="29.1409"
        x2="3.02628"
        y2="33.2207"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0257592" stopColor="white" stopOpacity="0" />
        <stop offset="0.471089" stopColor="white" stopOpacity="0.450872" />
        <stop offset="0.982847" stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_462_27196">
        <rect
          width="80"
          height="64"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SVGLoader;
